export const StyleConfig = {
	STROKE: '#000',
	STROKE_WIDTH: 1.5,
	STROKE_SECONDARY: '#fefefe',
	STOKE_SECONDARY_INSIGHT: '#5c5ce8',
	LABEL: {
		FILL: 'rgb(224,224,224)',
		FILL_INSIGHT: 'rgb(92,92,232)',
		FILL_HIGHLIGHTED: '#fbd98a',
		FILL_SELECTED: '#fbd98a',
		STROKE: '#e1ab29',
	},
	FONT_FAMILY: 'Roboto Condensed',
	FONT_SIZE: 14,
	FONT_COLOR: 'rgba(0,0,0,0.87)',
	FONT_COLOR_INSIGHT: '#fff',
	BUTTON: {
		DELETE_STROKE: '#B63C3C',
		ACCEPT_STROKE: '#1FA163',
	},
};

export const ClassNames = {
	main: 'c-Draw',
	container: 'c-Draw__Container',
	svg: 'c-Draw__Svg',
	image: 'c-Draw__Image',
	cropWindow: 'c-Draw__Rect',

	isImageLoaded: 'c-Draw__Image--loaded',
	isImageLoading: 'c-Draw__Image--loading',

	point: {
		container: 'c-Draw-Point',
		isSelected: 'c-Draw-Point--selected',
		isHighlighted: 'c-Draw-Point--highlighted',
	},

	line: {
		container: 'c-Draw-Line',
		main: 'c-Draw-Line--main',
		move: 'c-Draw-Line--moveable',
		secondary: 'c-Draw-Line--secondary',
		start: 'c-Draw-Line__Start',
		end: 'c-Draw-Line__End',
	},

	marker: {
		container: 'c-Draw-Marker',
		isInsight: 'c-Draw-Marker--insight',
		isBase: 'c-Draw-Marker--base',
		isBaseOffset: 'c-Draw-Marker--base-offset',
	},

	label: {
		container: 'c-Draw-Label',
		isInsight: 'c-Draw-Label--insight',
		text: 'c-Draw-Label__Text',
		rect: {
			container: 'c-Draw-Label__Rect',
			isSelected: 'c-Draw-Label__Rect--selected',
			isHighlighted: 'c-Draw-Label__Rect--highlighted',
		},
		delete: 'c-Draw-Label__Delete',
		accept: 'c-Draw-Label__Accept',
	},

	mask: 'c-Draw-Mask',

	isToolActive: 'c-Draw-Tool--active',
	thumbnailZoomWindow: 'c-Draw-thumbnail__Zoom',

	isHighlighted: 'c-Draw--highlighted',
	isThumbnail: 'c-Draw--thumbnail',
	isInteractive: 'c-Draw--interactive',
	isStatic: 'c-Draw--static',
	isSelected: 'c-Draw--selected',
	isMoving: 'c-Draw--moving',
	isPanning: 'c-Draw--panning',
	isMoveable: 'c-Draw--moveable',
	isLinking: 'c-Draw-linking',
};

export class CSSClassBuilder {
	static addStyle(obj: object, className: CSSClassBuilder, styles: object) {
		obj[className.toString()] = styles;
	}

	classString: string;

	constructor(baseClass: string) {
		this.classString = baseClass;
	}
	static create(baseClass: string) {
		return new CSSClassBuilder(baseClass);
	}

	and(classB: string) {
		return new CSSClassBuilder(this.classString + `.${classB}`);
	}
	child(classB: string) {
		return new CSSClassBuilder(this.classString + ' .' + classB);
	}

	toString(): string {
		return this.classString;
	}
}
